import React, { useEffect, useState, useContext, lazy } from "react";
import { Layout, Grid } from "antd";
import { FaUser } from "react-icons/fa";
import { MdEmail, MdPhone } from "react-icons/md";
import { set } from "date-fns";
import { useNavigate, useLocation } from "react-router-dom";
import { LayoutContext } from "../Layout/Layout";
import { toast } from "react-toastify";
import { useSeasonalTheme } from "../../theme/ThemeContext";
import { THEME_CONFIG } from '../../theme/themeConfig';
import MenuDrawerMob from "./MenuDrawer_mob";

const { Header } = Layout;
const { useBreakpoint } = Grid;

/*temporary
const ThemeSwitcher = ({ currentTheme, onThemeChange }) => {
  return (
    <div className="flex items-center gap-2 p-2 rounded-lg bg-black/10 backdrop-blur-sm border border-white/20">
      <span className="text-xs font-bold uppercase opacity-70">Theme:</span>
      <select
        value={currentTheme.key}
        onChange={(e) => onThemeChange(e.target.value)}
        className="bg-transparent text-sm font-medium focus:outline-none cursor-pointer"
      >
        {Object.keys(THEME_CONFIG).map((key) => (
          <option key={key} value={key} className="text-black">
            {THEME_CONFIG[key].name}
          </option>
        ))}
      </select>
    </div>
  );
};
temporary ends*/
// ...existing code...

const Navbar = () => {
  const { activeTab, setActiveTab, showsidebar, setSidebar } =
    useContext(LayoutContext);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [visible, setVisible] = useState(false);
  const screens = useBreakpoint();
  // const [showsidebar, setSidebar] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { activeTheme, handleThemeChange } = useSeasonalTheme();
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [profile, setProfile] = useState(null);
  const [errors, setErrors] = useState("");
  const [token, setToken] = useState(null);
  const [otp, setOtp] = useState(null);
  const [resendTimer, setResendTimer] = useState(30);
  const [sucessmessage, setSuccessMessage] = useState("");
  // const [activeTab, setActiveTab] = useState(1);
  const [otpfromapi, setOtpFromApi] = useState(null);
  let profileData = JSON.parse(localStorage.getItem("profileinfo"));
  let profileName = localStorage.getItem("profileName");
  console.log(activeTheme);
  const showDrawer = () => setVisible(true);
  const onClose = () => setVisible(false);

  const handleLogout = () => {
    ["id", "islogin", "loginTime", "profileName", "tokenWebsite", "profileinfo"].forEach((k) => localStorage.removeItem(k));
    setProfile(null);
    onClose();
    navigate("/");
  };


  useEffect(() => {}, [profileName, profileData]);


  const resendotp = () => {
    let timer = setInterval(() => {
      setResendTimer((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/; // Ensures domain extensions are 2-3 characters long
    return emailRegex.test(email);
  };

  useEffect(() => {
    if (profileData?.id) {
      getCustomerData(profileData?.id);
    }
  }, [profileData]);

  const getCustomerData = async () => {
    if (mobile && email && name) {
      try {
        const response = await fetch(`${apiUrl}/api/users/${profileData?.id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        const data = await response.json();

        if (data?.statusCode === "0100") {
          localStorage.setItem(
            "profileinfo",
            JSON.stringify(data?.entityValue),
          );
        }
      } catch (error) {
        console.error("Error fetching register user:", error);
      }
    } else {
      setErrors("Please fill all the fields.");
    }
  };

  const registeruser = async () => {
    if (mobile && email && name) {
      try {
        const response = await fetch(`${apiUrl}/api/users/mw/register`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            name: name,
            mobile: mobile,
            email: email,
          }),
        });

        const data = await response.json();

        if (data?.statusCode === "0100") {
          setActiveTab(4);
          setSuccessMessage("User registered successfully!");
        } else {
          toast.error(data?.msg);
          // setErrors(data?.msg);
        }
      } catch (error) {
        console.error("Error fetching register user:", error);
      }
    } else {
      setErrors("Please fill all the fields.");
    }
  };

  const loginuser = async () => {
    setOtp(null);
    setOtpFromApi(null);

    if (/^\d*$/.test(mobile)) {
      try {
        const response = await fetch(
          `${apiUrl}/api/v1/users/auth/m/signinotp`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              mobileNo: mobile,
            }),
          },
        );

        const data = await response.json();

        if (data?.statusCode === "0100") {
          toast.success("OTP sent successfully");
          setActiveTab(3);
          setToken(data?.dataValues?.token);
          localStorage.setItem("tokenWebsite", data?.dataValues?.token);
          setOtpFromApi(data?.dataValues?.otp);
          resendotp();
        } else {
          setErrors(data?.msg);
        }
      } catch (error) {
        console.error("Error fetching sigin otp:", error);
      }
    } else {
      setErrors("Please enter a mobile number.");
    }
  };

  const verifyotp = async () => {
    if (Number(otp) === otpfromapi) {
      try {
        const response = await fetch(`${apiUrl}/api/v1/user/auth/m/verify`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({
            mobileNo: mobile,
            otp: otp,
          }),
        });

        const data = await response.json();

        if (data?.statusCode === "0100") {
          toast.success("Logged in successfully!");
          setSidebar(false);
          setProfile(data?.dataValues?.name);
          localStorage.setItem("id", data?.dataValues?.id);
          const loginTimestamp = new Date().getTime();
          localStorage.setItem("loginTime", loginTimestamp);
          localStorage.setItem("profileName", data?.dataValues?.name);
          localStorage.setItem("profileinfo", JSON.stringify(data?.dataValues));
          localStorage.setItem("islogin", true);
          const pendingBooking = localStorage.getItem("bookingvalues");
          if (pendingBooking) {
            const parsed = JSON.parse(pendingBooking);
            parsed.customerId = data?.dataValues?.id;
            localStorage.setItem("bookingvalues", JSON.stringify(parsed));
            setTimeout(() => navigate("/bookings"), 700);
          } else {
            setTimeout(() => window.location.reload(), 700);
          }
        } else if (data?.code === "BadRequest") {
          toast.error("User is Not Registered / " + "Create Account");
        } else {
          toast.error(data);
          // setErrors(data?.message);
          setOtp(null);
          localStorage.setItem("islogin", false);
        }
      } catch (error) {
        console.error("Error fetching verify otp:", error);
      }
    } else if (otp !== otpfromapi) {
      setErrors("Invalid OTP. Please try again.");
    } else {
      setErrors("Please enter the OTP.");
    }
  };

  useEffect(() => {
    const storedTime = localStorage.getItem("loginTime");
    const storedProfile = localStorage.getItem("profileName");

    if (storedTime && storedProfile) {
      const now = new Date();
      const storedDate = new Date(parseInt(storedTime));
      const sixHours = 6 * 60 * 60 * 1000; // 6 hours in milliseconds

      const isSameDay = storedDate.toDateString() === now.toDateString();
      const withinSixHours = now.getTime() - storedDate.getTime() < sixHours;

      if (isSameDay && withinSixHours) {
        setProfile(storedProfile); // Still valid
      } else {
        toast.error("Session timeout please login again");
        localStorage.removeItem("loginTime");
        localStorage.removeItem("profileName");
        localStorage.removeItem("tokenWebsite");
        localStorage.removeItem("id");
        navigate("/");
      }
    }
  }, []);

  return (
    <div>
      {showsidebar ? (
        activeTab === 1 ? (
          <div className="fixed inset-0 z-[1100]">
            {/* Overlay */}
            <div
              className="absolute inset-0 bg-black bg-opacity-40"
              onClick={() => {
                setSidebar(false);
                setErrors("");
              }}
            ></div>

            {/* Sidebar */}
            <div className="absolute right-0 top-0 w-full md:w-3/4 md:max-w-md h-full bg-white shadow-lg transition-transform duration-300 ease-in-out z-[1100] flex flex-col">
              {/* Header */}
              <div className="text-black p-4 flex justify-between items-center">
                <div className="text-start">
                  <h1
                    style={{ fontWeight: 500, fontSize: 24 }}
                    className="text-lg"
                  >
                    Welcome back!
                  </h1>
                  <p
                    style={{ fontWeight: 500, fontSize: 24 }}
                    className="text-gray-600 text-sm"
                  >
                    You are being missed.
                  </p>
                </div>
                <button
                  className="text-black text-lg mb-10 w-8 h-8"
                  onClick={() => {
                    setSidebar(false);
                    setErrors("");
                  }}
                >
                  ✕
                </button>
              </div>

              <div className="items-center justify-center flex flex-col mt-10">
                <img src="/assets/login2.png" className="" />
              </div>

              {/* Content */}
              <div className="p-6 flex flex-col gap-4">
                <div className="flex items-center border border-gray-300 rounded-md focus-within:ring-2 focus-within:ring-[#EF3C23]">
                  <span className="px-3 text-gray-500">
                    <MdPhone className="text-2xl" />
                  </span>
                  <input
                    type="text"
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        // Allow only numeric input
                        setMobile(value);
                      }
                    }}
                    value={mobile}
                    placeholder="Mobile Number"
                    maxLength={10}
                    onFocus={() => setErrors("")}
                    className="w-full p-3 focus:outline-none"
                  />
                </div>

                {errors && <span className="text-red-500">{errors}</span>}

                {/* Sign In Button */}
                <button
                  className="w-full bg-[#EF3C23] text-white py-3 rounded-md font-bold hover:bg-[#d8321f]"
                  onClick={() => loginuser()} // Switch to OTP view
                >
                  Sign In
                </button>

                {/* Switch to Sign Up */}
                <p className="text-center text-sm text-gray-600">
                  Don’t have an account?{" "}
                  <a
                    onClick={() => {
                      setActiveTab(2);
                      setErrors("");
                      setName("");
                      setEmail("");
                      setMobile("");
                      setOtp(null);
                      setOtpFromApi(null);
                    }}
                    href="#"
                    className="text-[#EF3C23] hover:underline"
                  >
                    Create an account
                  </a>
                </p>
              </div>
            </div>
          </div>
        ) : activeTab === 2 ? (
          <div className="fixed inset-0 z-[1100]">
            {/* Overlay */}
            <div
              className="absolute inset-0 bg-black bg-opacity-40"
              onClick={() => {
                setSidebar(false);
                setErrors("");
              }}
            ></div>

            {/* Sidebar */}
            <div className="absolute right-0 top-0 w-full md:w-3/4 md:max-w-md h-full bg-white shadow-lg transition-transform duration-300 ease-in-out z-[1100] flex flex-col">
              {/* Header */}
              <div className="text-black p-4 flex justify-between items-center">
                <div className="text-start">
                  <h2 className="text-xl font-semibold mb-6 flex justify-start">
                    Welcome to &nbsp;
                    <span className="text-red-500 font-bold">WOW CARZ!</span>
                  </h2>
                </div>
                <button
                  className="text-black text-lg mb-10 w-8 h-8"
                  onClick={() => setActiveTab(1)}
                >
                  ✕
                </button>
              </div>

              <div className="items-center justify-center flex flex-col mt-10">
                <img src="/assets/login2.png" className="" />
              </div>

              {/* Content */}
              <div className="p-6 flex flex-col gap-4">
                <div className="flex items-center border border-gray-300 rounded-md focus-within:ring-2 focus-within:ring-[#EF3C23]">
                  <span className="px-3 text-gray-500">
                    <FaUser className="text-2xl" />
                  </span>
                  <input
                    type="name"
                    onChange={(e) => setName(e.target.value)}
                    value={name}
                    placeholder="Full Name"
                    maxLength={25}
                    onFocus={() => setErrors("")}
                    className="w-full p-3 focus:outline-none"
                  />
                </div>
                <div className="flex items-center border border-gray-300 rounded-md focus-within:ring-2 focus-within:ring-[#EF3C23]">
                  <span className="px-3 text-gray-500">
                    <MdEmail className="text-2xl" />
                  </span>
                  <input
                    type="email"
                    onChange={(e) => {
                      const value = e.target.value;
                      setEmail(value);
                    }}
                    value={email}
                    placeholder="Email"
                    onFocus={() => setErrors("")}
                    className="w-full p-3 focus:outline-none"
                  />
                </div>
                <div className="flex items-center border border-gray-300 rounded-md focus-within:ring-2 focus-within:ring-[#EF3C23]">
                  <span className="px-3 text-gray-500">
                    <MdPhone className="text-2xl" />
                  </span>
                  <input
                    type="text"
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        // Allow only numeric input
                        setMobile(value);
                      }
                    }}
                    value={mobile}
                    placeholder="Mobile Number"
                    maxLength={10}
                    onFocus={() => setErrors("")}
                    className="w-full p-3 focus:outline-none"
                  />
                </div>
                {errors && <span className="text-red-500">{errors}</span>}

                {/* Sign Up Button */}
                <button
                  className="w-full bg-[#EF3C23] text-white py-3 rounded-md font-bold hover:bg-[#d8321f]"
                  onClick={() => {
                    if (!validateEmail(email)) {
                      setErrors(
                        "Invalid email format. Please enter a valid email.",
                      );
                      return;
                    } else if (name !== name.trim()) {
                      setErrors("No spaces allowed at start or end");
                      return;
                    } else if (
                      !/^(?=.{3,}$)[A-Za-z]+( [A-Za-z]+)*$/.test(name)
                    ) {
                      setErrors("Only letters and spaces allowed (3–50 chars)");
                      return;
                    } else {
                      setErrors("");
                      registeruser();
                    }
                  }}
                >
                  Sign Up
                </button>

                {/* Switch to Sign In */}
                <p className="text-center text-sm text-gray-600">
                  Already have an account?{" "}
                  <a
                    onClick={() => {
                      setActiveTab(1);
                      setErrors("");
                      setName("");
                      setEmail("");
                      setMobile("");
                      setOtp(null);
                      setOtpFromApi(null);
                    }}
                    href="#"
                    className="text-[#EF3C23] hover:underline"
                  >
                    Sign In
                  </a>
                </p>
              </div>
            </div>
          </div>
        ) : activeTab === 3 ? (
          <div className="fixed inset-0 z-[1100]">
            {/* Overlay */}
            <div
              className="absolute inset-0 bg-black bg-opacity-40"
              onClick={() => {
                setSidebar(false);
                setErrors("");
              }}
            ></div>

            {/* Sidebar */}
            <div className="absolute right-0 top-0 w-full md:w-3/4 md:max-w-md h-full bg-white shadow-lg transition-transform duration-300 ease-in-out z-[1100] flex flex-col">
              {/* Header */}
              <div className="text-black p-4 flex justify-between items-center">
                <h2 className="text-xl font-semibold">Verify OTP</h2>
                <button
                  className="text-black text-lg mb-10 w-8 h-8"
                  onClick={() => {
                    setActiveTab(1);
                    setErrors("");
                  }}
                >
                  ✕
                </button>
              </div>

              <div className="items-center justify-center flex flex-col mt-10">
                <img src="/assets/login2.png" className="" />
              </div>

              {/* Content */}
              <div className="p-6 flex flex-col gap-4">
                <p className="text-gray-600 text-sm text-center">
                  Enter the OTP sent to your registered mobile number.
                </p>
                <div className="flex items-center border border-gray-300 rounded-md focus-within:ring-2 focus-within:ring-[#EF3C23]">
                  <input
                    type="text"
                    placeholder="Enter OTP"
                    onFocus={() => setResendTimer("")}
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    className="w-full p-3 focus:outline-none text-center"
                    maxLength={6}
                  />
                </div>

                {resendTimer > 0 && (
                  <span className="text-red-400 text-end">
                    Wait for {resendTimer} seconds
                  </span>
                )}

                {errors && <span className="text-red-500">{errors}</span>}

                {/* Verify Button */}
                <button
                  onClick={() => {
                    verifyotp();
                  }}
                  className="w-full bg-[#EF3C23] text-white py-3 rounded-md font-bold hover:bg-[#d8321f]"
                >
                  Verify OTP
                </button>

                {/* Resend OTP */}
                <p                  
                  className="text-center text-sm text-gray-600"
                >
                  Didn’t receive the OTP?{" "}
                  <a onClick={() => {
                    loginuser();
                    setOtp("");
                    setErrors("");
                  }} href="#" className="text-[#EF3C23] hover:underline">
                    Resend OTP
                  </a>
                </p>
                <p className="text-center text-sm text-gray-600">
                  Don’t have an account?{" "}
                  <a
                    onClick={() => {
                      setActiveTab(2);
                      setErrors("");
                      setName("");
                      setEmail("");
                      setMobile("");
                      setOtp(null);
                      setOtpFromApi(null);
                    }}
                    href="#"
                    className="text-[#EF3C23] hover:underline"
                  >
                    Create an account
                  </a>
                </p>
              </div>
            </div>
          </div>
        ) : (
          activeTab === 4 && (
            <div className="fixed inset-0 z-[1100]">
              {/* Overlay */}
              <div
                className="absolute inset-0 bg-black bg-opacity-40"
                onClick={() => {
                  setSidebar(false);
                  setErrors("");
                }}
              ></div>

              {/* Sidebar */}
              <div className="absolute right-0 top-0 w-full md:w-3/4 md:max-w-md h-full bg-white shadow-lg transition-transform duration-300 ease-in-out z-[1100] flex flex-col">
                {/* Header */}
                <div className="items-center justify-center flex flex-col mt-10">
                  <img src="/assets/login2.png" className="" />
                </div>

                <div className="bg-white p-6 text-center">
                  <h2 className="text-xl font-semibold text-green-600">
                    {sucessmessage}
                  </h2>
                  <button
                    className="mt-4 bg-[#EF3C23] text-white py-2 px-4 rounded-md font-bold hover:bg-[#d8321f]"
                    onClick={() => {
                      setActiveTab(1);
                    }}
                  >
                    Go to Login
                  </button>
                </div>
              </div>
            </div>
          )
        )
      ) : null}

      <Layout>
        <Header
          style={{
            position: "fixed",
            top: 0,
            width: "100%",
            zIndex: 1000,
            backgroundColor: "#ffffff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: 58,
            padding: "0 16px",
            boxShadow: "none",
          }}
        >
          <div className="logo flex items-center gap-1">
            
            <a href="/" className="flex items-center">
              <img
                fetchpriority="high"
                style={{ height: 76, width: 126 }}
                src="/assets/logo.png"
                alt="logo"
                className="object-contain"
              />
            </a>

            {/* <img
              fetchpriority="high"
              className="w-[120px] h-[60px] object-contain"
                src={activeTheme.navbarGif}
                alt={activeTheme.name}
                
            /> */}
          </div>
          {/* 2. INSERT THE SWITCHER HERE (Between Logo and Menu) */}
          {/*<div className="mx-4">
            <ThemeSwitcher 
              currentTheme={activeTheme} 
              onThemeChange={handleThemeChange} 
            />
          </div>*/}
          {/* Desktop menu */}
          {screens.md ? (
            <div className="flex-1 flex items-center justify-end">
              {/* Right: nav links + profile/login */}
              <div className="flex items-center gap-8">
                <nav className="flex items-center gap-8">
                  <button
                    onClick={() => navigate("/tandc")}
                    className={`text-[15px] font-semibold font-['Outfit'] tracking-wide hover:opacity-80 whitespace-nowrap ${location.pathname === "/tandc" ? "text-black underline underline-offset-4" : "text-[#524c82]"}`}
                  >
                    Terms &amp; Conditions
                  </button>
                  <button
                    onClick={() => navigate("/faq")}
                    className={`text-[15px] font-semibold font-['Outfit'] tracking-wide hover:opacity-80 whitespace-nowrap ${location.pathname === "/faq" ? "text-black underline underline-offset-4" : "text-[#524c82]"}`}
                  >
                    FAQs
                  </button>
                  <a
                    href="https://partner-with-us.wowcarz.in/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-[15px] font-semibold font-['Outfit'] tracking-wide hover:opacity-80 whitespace-nowrap text-[#524c82]"
                  >
                    Partner with us
                  </a>
                  <button
                    onClick={() => window.open("/about-us", "_blank")}
                    className={`text-[15px] font-semibold font-['Outfit'] tracking-wide hover:opacity-80 whitespace-nowrap ${location.pathname === "/about-us" ? "text-black underline underline-offset-4" : "text-[#524c82]"}`}
                  >
                    About Us
                  </button>
                </nav>
                <div className="flex items-center gap-4 shrink-0">
                {/* Find Car button — commented out, replaced by ThorSwitch
                <div
                  style={{
                    background: "linear-gradient(135deg, #534E83, #9592B3, #FFFFFF)",
                    padding: "2px",
                    borderRadius: "12px",
                    display: "inline-flex",
                  }}
                >
                <button
                  onClick={() => navigate("/listings?mode=daily")}
                  className="flex items-center gap-2 rounded-[8px] px-4 py-1.5 text-sm font-medium font-['Outfit'] tracking-wide whitespace-nowrap bg-white text-[#524c82] hover:bg-[#eceafb]"
                >
                  Find Car
                  <img
                    src="/assets/nav/search-car-dark.svg"
                    alt=""
                    className="w-5 h-5"
                  />
                </button>
                </div>
                Find Car button end */}

                {profile ? (
                  <button
                    onClick={() => navigate("/profile")}
                    className="w-[42px] h-[42px] rounded-full overflow-hidden border border-white/40 shrink-0"
                    aria-label="Profile"
                  >
                    <img
                      src={profileData?.image || "/assets/avatar.png"}
                      alt="profile"
                      className="w-full h-full object-cover"
                    />
                  </button>
                ) : (
                  <button
                    onClick={() => navigate("/login")}
                    className="flex items-center gap-1.5 bg-[#ED2D20] hover:bg-[#d8341f] active:scale-95 transition-all text-white font-semibold font-['Outfit'] text-xs px-3.5 py-1.5 rounded-lg whitespace-nowrap"
                  >
                    Login
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <polyline points="10 17 15 12 10 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <line x1="15" y1="12" x2="3" y2="12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                )}
                </div>
              </div>
            </div>
          ) : (
            // Mobile hamburger
            <>
              <button
                onClick={showDrawer}
                aria-label="Open menu"
                className="flex items-center justify-center size-[48px] rounded-lg active:bg-[#f3f4f6] transition-colors"
              >
                <img src="/assets/mobile/hero/menu.svg" alt="" width="24" height="24" className="size-[24px]" />
              </button>

              {visible && profile && (
                <MenuDrawerMob
                  name={profileData?.name || profile}
                  email={profileData?.email}
                  image={profileData?.image}
                  onClose={onClose}
                  onNavigate={(path) => { navigate(path); onClose(); }}
                  onLogout={handleLogout}
                />
              )}

              {/* Mobile Drawer Overlay */}
              {visible && !profile && (
                <div className="fixed inset-0 z-[1200]">
                  {/* Backdrop */}
                  <div
                    className="absolute inset-0 bg-black/40"
                    onClick={onClose}
                  />
                  {/* Drawer panel */}
                  <div className="absolute right-0 top-0 h-full w-[85vw] max-w-[360px] bg-white flex flex-col shadow-2xl rounded-tl-[40px] rounded-bl-[40px]">
                    {/* Header */}
                    <div className="flex items-center justify-between px-5 pt-6 pb-4">
                      <a href="/" onClick={onClose}>
                        <img src="/assets/logo.png" alt="WowCarz" className="h-12 w-auto object-contain" />
                      </a>
                      <button
                        onClick={onClose}
                        className="w-9 h-9 rounded-full border border-[#e5e7eb] flex items-center justify-center text-[#374151] hover:bg-[#f3f4f6] transition-colors"
                      >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                        </svg>
                      </button>
                    </div>

                    {/* Menu label */}
                    <p className="px-5 py-2 text-[11px] font-semibold tracking-[1.5px] text-[#9ca3af] uppercase font-['Outfit'] text-left">MENU</p>

                    {/* Scrollable menu items */}
                    <div className="flex-1 overflow-y-auto px-3">
                      {/* Group 1 */}
                      <div className="flex flex-col">
                        <a
                          href="https://partner-with-us.wowcarz.in/"
                          target="_blank"
                          rel="noreferrer"
                          onClick={onClose}
                          className="flex items-center gap-3 px-3 py-[5px] rounded-xl hover:bg-[#f9fafb] transition-colors"
                        >
                          <span className="w-9 h-9 flex items-center justify-center shrink-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                              <path d="M8.53869 12.6675L10.2055 14.3342C10.3697 14.4984 10.5645 14.6286 10.779 14.7174C10.9935 14.8063 11.2234 14.852 11.4556 14.852C11.6878 14.852 11.9176 14.8063 12.1321 14.7174C12.3466 14.6286 12.5415 14.4984 12.7057 14.3342C12.8699 14.1701 13.0001 13.9752 13.0889 13.7607C13.1778 13.5462 13.2235 13.3164 13.2235 13.0842C13.2235 12.8521 13.1778 12.6222 13.0889 12.4077C13.0001 12.1932 12.8699 11.9984 12.7057 11.8342M11.0391 10.1671L13.1226 12.2505C13.4541 12.582 13.9038 12.7683 14.3727 12.7683C14.8416 12.7683 15.2912 12.582 15.6228 12.2505C15.9543 11.919 16.1406 11.4693 16.1406 11.0005C16.1406 10.5316 15.9543 10.082 15.6228 9.75047L12.3892 6.51712C11.9204 6.04895 11.2849 5.78598 10.6224 5.78598C9.95982 5.78598 9.32435 6.04895 8.85557 6.51712L8.12217 7.25046C7.79063 7.58198 7.34095 7.76823 6.87207 7.76823C6.4032 7.76823 5.95352 7.58198 5.62197 7.25046C5.29043 6.91893 5.10417 6.46929 5.10417 6.00045C5.10417 5.5316 5.29043 5.08196 5.62197 4.75044L7.96383 2.40876C8.72409 1.65054 9.71555 1.16755 10.7813 1.03623C11.847 0.904914 12.926 1.13278 13.8476 1.68376L14.2393 1.91709C14.5942 2.13125 15.0161 2.20552 15.4228 2.12543L16.8729 1.83376M16.8727 1.00081L17.7061 10.1675H16.0393M1.87149 1.00081L1.03809 10.1675L6.45519 15.5842C6.78673 15.9158 7.23641 16.102 7.70529 16.102C8.17416 16.102 8.62384 15.9158 8.95539 15.5842C9.28693 15.2527 9.47319 14.8031 9.47319 14.3342C9.47319 13.8654 9.28693 13.4157 8.95539 13.0842M1.87149 1.83415H8.53869" stroke="#6B7280" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                          </span>
                          <span style={{ color: '#1F2937', fontSize: 20, fontFamily: 'Outfit', fontWeight: '500', wordWrap: 'break-word' }} className="flex-1 text-left">Partner with Us</span>
                          <svg width="7" height="12" viewBox="0 0 7 12" fill="none"><path d="M1 1l5 5-5 5" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                        </a>
                        <button
                          onClick={() => { navigate("/faq"); onClose(); }}
                          className="flex items-center gap-3 px-3 py-[5px] rounded-xl hover:bg-[#f9fafb] transition-colors"
                        >
                          <span className="w-9 h-9 flex items-center justify-center shrink-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                              <path d="M6.90868 6.83346C7.10461 6.27647 7.49135 5.8068 8.00039 5.50763C8.50943 5.20846 9.10793 5.0991 9.68988 5.19892C10.2718 5.29874 10.7997 5.6013 11.1799 6.053C11.5602 6.50471 11.7683 7.07641 11.7674 7.66686C11.7674 9.33366 9.2672 10.1671 9.2672 10.1671M9.334 13.501H9.34233M17.668 9.334C17.668 13.9367 13.9367 17.668 9.334 17.668C4.73126 17.668 1 13.9367 1 9.334C1 4.73126 4.73126 1 9.334 1C13.9367 1 17.668 4.73126 17.668 9.334Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                          </span>
                          <span style={{ color: '#1F2937', fontSize: 20, fontFamily: 'Outfit', fontWeight: '500', wordWrap: 'break-word' }} className="flex-1 text-left">FAQs</span>
                          <svg width="7" height="12" viewBox="0 0 7 12" fill="none"><path d="M1 1l5 5-5 5" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                        </button>
                      </div>

                      <div className="mx-3 h-px bg-[#f3f4f6] my-1" />

                      {/* Group 2 */}
                      <div className="flex flex-col">
                        <button
                          onClick={() => { navigate("/tandc"); onClose(); }}
                          className="flex items-center gap-3 px-3 py-[5px] rounded-xl hover:bg-[#f9fafb] transition-colors"
                        >
                          <span className="w-9 h-9 flex items-center justify-center shrink-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="19" viewBox="0 0 16 19" fill="none">
                              <path d="M9.3325 1H2.6665C2.22452 1 1.80064 1.17561 1.48811 1.4882C1.17558 1.80078 1 2.22474 1 2.6668V16.0012C1 16.4433 1.17558 16.8672 1.48811 17.1798C1.80064 17.4924 2.22452 17.668 2.6665 17.668H12.6655C13.1075 17.668 13.5314 17.4924 13.8439 17.1798C14.1564 16.8672 14.332 16.4433 14.332 16.0012V6.0004M9.3325 1C9.59627 0.999575 9.85751 1.05134 10.1012 1.15232C10.3449 1.2533 10.5662 1.4015 10.7524 1.58838L13.7421 4.57862C13.9294 4.76489 14.078 4.98644 14.1793 5.23047C14.2805 5.47451 14.3324 5.73619 14.332 6.0004M9.3325 1V5.167C9.3325 5.38803 9.42029 5.60001 9.57655 5.7563C9.73282 5.91259 9.94476 6.0004 10.1657 6.0004L14.332 6.0004M5.9995 6.8338H4.333M10.999 10.1674H4.333M10.999 13.501H4.333" stroke="#6B7280" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                          </span>
                          <span style={{ color: '#1F2937', fontSize: 20, fontFamily: 'Outfit', fontWeight: '500', wordWrap: 'break-word' }} className="flex-1 text-left">Terms &amp; Conditions</span>
                          <svg width="7" height="12" viewBox="0 0 7 12" fill="none"><path d="M1 1l5 5-5 5" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                        </button>
                        <button
                          onClick={() => { navigate("/privacypolicy"); onClose(); }}
                          className="flex items-center gap-3 px-3 py-[5px] rounded-xl hover:bg-[#f9fafb] transition-colors"
                        >
                          <span className="w-9 h-9 flex items-center justify-center shrink-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="19" viewBox="0 0 16 19" fill="none">
                              <path d="M9.3325 1H2.6665C2.22452 1 1.80064 1.17561 1.48811 1.4882C1.17558 1.80078 1 2.22474 1 2.6668V16.0012C1 16.4433 1.17558 16.8672 1.48811 17.1798C1.80064 17.4924 2.22452 17.668 2.6665 17.668H12.6655C13.1075 17.668 13.5314 17.4924 13.8439 17.1798C14.1564 16.8672 14.332 16.4433 14.332 16.0012V6.0004M9.3325 1C9.59627 0.999575 9.85751 1.05134 10.1012 1.15232C10.3449 1.2533 10.5662 1.4015 10.7524 1.58838L13.7421 4.57862C13.9294 4.76489 14.078 4.98644 14.1793 5.23047C14.2805 5.47451 14.3324 5.73619 14.332 6.0004M9.3325 1V5.167C9.3325 5.38803 9.42029 5.60001 9.57655 5.7563C9.73282 5.91259 9.94476 6.0004 10.1657 6.0004L14.332 6.0004M5.9995 6.8338H4.333M10.999 10.1674H4.333M10.999 13.501H4.333" stroke="#6B7280" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                          </span>
                          <span style={{ color: '#1F2937', fontSize: 20, fontFamily: 'Outfit', fontWeight: '500', wordWrap: 'break-word' }} className="flex-1 text-left">Privacy Policy</span>
                          <svg width="7" height="12" viewBox="0 0 7 12" fill="none"><path d="M1 1l5 5-5 5" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                        </button>
                        <button
                          onClick={() => { window.open("/about-us", "_blank"); onClose(); }}
                          className="flex items-center gap-3 px-3 py-[5px] rounded-xl hover:bg-[#f9fafb] transition-colors"
                        >
                          <span className="w-9 h-9 flex items-center justify-center shrink-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                              <path d="M9.334 12.6676V9.334M9.334 6.0004H9.34233M17.668 9.334C17.668 13.9367 13.9367 17.668 9.334 17.668C4.73126 17.668 1 13.9367 1 9.334C1 4.73126 4.73126 1 9.334 1C13.9367 1 17.668 4.73126 17.668 9.334Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                          </span>
                          <span style={{ color: '#1F2937', fontSize: 20, fontFamily: 'Outfit', fontWeight: '500', wordWrap: 'break-word' }} className="flex-1 text-left">About us</span>
                          <svg width="7" height="12" viewBox="0 0 7 12" fill="none"><path d="M1 1l5 5-5 5" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                        </button>
                      </div>
                    </div>

                    {/* Bottom CTA */}
                    <div className="px-4 py-6 border-t border-[#f3f4f6]">
                      <button
                        onClick={() => { navigate("/login"); onClose(); }}
                        style={{ width: '100%', padding: '2px 6px', background: '#ED2D20', boxShadow: '0px 8px 16px rgba(237, 28, 36, 0.20)', borderRadius: 14, justifyContent: 'center', alignItems: 'center', display: 'flex' }}
                      >
                        <span style={{ color: 'white', fontSize: 22, fontFamily: 'Outfit', fontWeight: '700', wordWrap: 'break-word' }}>Login / Sign Up</span>
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </Header>
        {/* <div
          style={{
            position: "fixed",
            top: 35, // header height
            left: 0,
            right: 0,
            width: "100%",
            height: 95,
            backgroundImage: "url('/assets/christmas.gif')",
            backgroundRepeat: "repeat-x",
            backgroundSize: "350px",
            zIndex: 999, // below header (header zIndex is 1000)
            pointerEvents: "none",
          }}
        ></div> */}
        {/* Spacer to offset fixed header */}
        {/* <div style={{ height: 80 }}></div> */}
      </Layout>
    </div>
  );
};

export default Navbar;
